import React from 'react'
import styled from 'styled-components';
import backgroundWave from "./assets/wave-landing.svg"
const WaveSection = ({children}) => {
  return (
    <CallToActionSection>
      {children}
    </CallToActionSection>
  )
}

export default WaveSection


const CallToActionSection = styled.section`
  padding: 200px 0px;
  display:flex;
  position: relative;
  flex-direction:column;
  align-items:center;
  justify-content:center;
  background-image: url(${backgroundWave});
  background-repeat: no-repeat;
  background-size: contain;
  background-position:center;
  @media (max-width: 1400px) {
    padding: 150px 0px;
    background-size: cover;
    
  }
  @media (max-width: 1899px) {
    padding: 250px 0px;
    background-size: cover;
    
  }
  @media (min-width: 1900px){
    height:1000px;
    margin-top:50px;
  }
  h2{
    max-width:600px;
  }
`